import {JwtAxios} from "@/packaging";
import dayjs from "dayjs";

export const corpAPI = {
    async GetCorp(page,limit=15,startDate="",endDate="", keywordType="",keyword=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/Corp/GetCorp?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&keywordType=${keywordType}&keyword=${keyword}`);
        return responseModel
    },
    async GetCorpCount(startDate="",endDate="", keywordType="",keyword=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/Corp/GetCorpCount?startDate=${startDate}&endDate=${endDate}&keywordType=${keywordType}&keyword=${keyword}`);
        return responseModel
    },

    async GetCorpTotalCount(){
        const responseModel = await JwtAxios.get(`/Corp/GetCorpTotalCount`);
        return responseModel
    },

    async ExportExcel(model){
        const responseModel = await JwtAxios.download(`/Corp/ExportExcel`,model);
        return responseModel
    },
}